
<template>
  <div class="ship-search demo-input-suffix">
    <svg-icon icon-class="ship"
              class="img"
              @click="toggleShipList"></svg-icon>
    <el-input v-model="input"
              clearable
              size="small"
              placeholder="输入船名 / IMO"
              @focus="handleSearch(input)">
      <template #prefix>
        <el-icon class="el-input__icon">
          <search></search>
        </el-icon>
      </template>
    </el-input>
    <div class="search-button">
      <div class="changeOrder"
           @click="changeOrder('up', true)">LAST</div>
      <div class="changeOrder"
          :class="timer ? 'changeOrder-auto' : ''"
           @click="openPlay()">AUTO</div>
      <div class="changeOrder"
           @click="changeOrder('down', true)">NEXT</div>
    </div>
    <ship-list ref="shiplist"
               v-show="showShipList"
               @changeShow="changeShow"
               @finishChange="finishChange"
               @closeList="closeList"
               :shipList="shipList"
               :allGroupListData="allGroupListData"
               :direction="direction"
               :isChoosed="isChoosed"></ship-list>
  </div>
</template>
  
  <script>
import { defineComponent, ref, onMounted } from "vue";
import shipList from "./components/shipList.vue";
import { Search, SortDown, SortUp } from "@element-plus/icons-vue";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "SearchBar",
  components: { shipList, Search },
  props: {
    aisShipList: {
      type: Array,
      default: () => {
        return null;
      },
    },
    allGroupListData: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      showShipList: false,
      shipList: [],
      input: "",
      direction: "",
      isChoosed: false,
      timer: null
    };
  },
  watch: {
    input: function (newV) {
      this.handleSearch(newV);
    },
    aisShipList(newV) {
      this.shipList = JSON.parse(JSON.stringify(newV));
    },
    isPlay(newV) {
      this.closePlay()
    }
  },
  computed: {
    ...mapGetters(['isPlay'])
  },
  mounted() {
    this.autoPlay()
  },
  methods: {
    // 关闭弹窗并关闭自动播放
    closeList() {
      this.showShipList = false;
      this.closePlay()
    },
    toggleShipList() {
      this.showShipList = !this.showShipList;
      this.shipList = JSON.parse(JSON.stringify(this.aisShipList));
    },
    handleSearch(value) {
      
      this.shipList = [];
      this.showShipList = true;
      if (!value) {
        this.shipList = JSON.parse(JSON.stringify(this.aisShipList));
      } else {
        this.shipList = this.aisShipList.filter((item) => {
          const index = item.name.toLowerCase().indexOf(value.toLowerCase())
          console.log(index, item.name)
          return index > -1
        });
        console.log('list', this.shipList)
      }
    },
    finishChange() {
      this.direction = "";
    },
    openPlay() {
      this.changeOrder('down')
      this.autoPlay()
    },
    // 自动播放
    autoPlay() {
      if (this.timer) return false
      this.timer = setInterval(() => {
        this.changeOrder('down')
      }, 30000);
    },
    closePlay(mmsi = null) {
      if (mmsi) {
        this.$refs.shiplist.changIndex(mmsi)
      }
      clearInterval(this.timer)
      this.timer= null
    },
    changeOrder(dir, status = false) {
      this.direction = dir;
      if (status) {
        this.closePlay()
      }
    },
    changeShow() {
      this.isChoosed = true;
    },
  },
  destroyed() {
    this.closePlay()
  }
});
</script>
  
  <style lang="scss">
@import "../styles/variables";
@media screen and (max-width: 1500px) {
  .ship-search {
    position: absolute;
    // top: 20px;
    top: 65px;
    z-index: 2000;
    left: 10px;
    width: 350px;
    display: flex;
    align-items: center;
    .changeOrder {
      cursor: pointer;
      color: #d3d3d3;
      font-size: 12px;
      border-radius: 5px;
      border: 1px solid #606266;
      text-align: center;
      padding: 5px 7px;
    }
    .img {
      cursor: pointer;
      margin-right: 5px;
      height: 30px;
      width: 50px;
    }

    .el-input__inner {
      border: 1px solid rgba(255, 255, 255, 0.27) !important;
      background: none !important;
      height: 30px !important;
    }
  }
}
@media screen and (min-width: 1501px) {
  .ship-search {
    position: absolute;
    top: calc($header-height-1920 - 40px);
    z-index: 2000;
    left: 10px;
    width: 24vw;
    display: flex;
    align-items: center;
    .changeOrder {
      cursor: pointer;
      color: #d3d3d3;
      font-size: 12px;
      border-radius: 5px;
      border: 1px solid #606266;
      text-align: center;
      padding: 5px 7px;
    }
    .img {
      cursor: pointer;
      margin-right: 5px;
      height: 30px;
      width: 50px;
    }

    .el-input__inner {
      border: 1px solid rgba(255, 255, 255, 0.27) !important;
      background: none !important;
      height: 30px !important;
    }
  }
}

@media screen and (min-width: 1921px) {
  .ship-search {
    position: absolute;
    // top: 30px;
    top: calc($header-height-2560 - 50px);
    z-index: 2000;
    left: 1vh;
    width: 24vw;
    display: flex;
    align-items: center;
    .changeOrder {
      cursor: pointer;
      color: #d3d3d3;
      font-size: 24px;
      border-radius: 7px;
      border: 1px solid #606266;
      text-align: center;

      padding: 7px 11px;
    }
    .img {
      cursor: pointer;
      margin-right: 10px;
      height: 44px;
      width: 55px;
    }

    .el-input__inner {
      border: 1px solid rgba(255, 255, 255, 0.27) !important;
      background: none !important;
      height: 44px !important;
      font-size: 24px;
    }
  }
}

@media screen and (min-width: 2561px) {
  .ship-search {
    position: absolute;
    // top: 40px;
    top: calc($header-height-4368 - 50px);
    z-index: 2000;
    left: 2vh;
    width: 20vw;
    display: flex;
    align-items: center;
    .changeOrder {
      cursor: pointer;
      color: #d3d3d3;
      font-size: 30px;
      border-radius: 10px;
      border: 1px solid #606266;
      text-align: center;

      padding: 10px 14px;
    }
    .img {
      cursor: pointer;
      margin-right: 15px;
      height: 60px;
      width: 80px;
    }

    .el-input__inner {
      border: 1px solid rgba(255, 255, 255, 0.27) !important;
      background: none !important;
      height: 60px !important;
      font-size: 30px;
    }
  }
}

@media screen and (min-width: 6700px) {
  .ship-search {
    position: absolute;
    // top: 60px;
    top: calc($header-height-6720 - 120px);
    z-index: 2000;
    left: 2vh;
    width: $sidebar-width;
    display: flex;
    align-items: center;
    .changeOrder {
      cursor: pointer;
      color: #d3d3d3;
      font-size: 40px;
      border-radius: 17px;
      border: 1px solid #606266;
      text-align: center;
      padding: 17px 25px;
    }
    .img {
      cursor: pointer;
      margin-right: 20px;
      height: 100px;
      width: 120px;
    }

    .el-input__inner {
      border: 4px solid rgba(255, 255, 255, 0.27) !important;
      background: none !important;
      height: 100px !important;
      font-size: 40px;
    }
  }
}
</style>

<style lang="scss" scoped>
.search-button {
  min-width: 40%;
  display: flex;
  justify-content: space-evenly;
}
.changeOrder-auto {
  opacity: 0.5;
}
.ship-search ::v-deep .el-input__wrapper {
  background: rgba(72, 156, 255, 0);
}
</style>